import { render, staticRenderFns } from "./RepurchaseHk.vue?vue&type=template&id=3856e820&scoped=true"
import script from "./RepurchaseHk.vue?vue&type=script&lang=js"
export * from "./RepurchaseHk.vue?vue&type=script&lang=js"
import style0 from "./RepurchaseHk.vue?vue&type=style&index=0&id=3856e820&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3856e820",
  null
  
)

export default component.exports